import "./StormDamageRepair.module.css";
import Header from "@/reusable_sections/Header";
import SwiftStormDamageRepair from "./sections/SwiftStormDamageRepair";
import Footer from "@/reusable_sections/Footer";
export default function StormDamageRepairPage() {
  return <div>
      <Header />
      <SwiftStormDamageRepair />
      <Footer />
    </div>;
}